import React from "react"
import PropTypes from "prop-types"

import LexicoinCounter from './LexicoinCounter'
import NotificationBell from './NotificationBell'

class UserGamificationDashboard extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      lexicoins: this.props.currentUser.lexicoins,
    }
  }

  render() {
    const avatarUrl = this.props.currentUser.avatar_url !== 'medium/missing.png'
      ? this.props.currentUser.avatar_url
      : this.props.missingImg

    return(
      <div className="gamificationSection">
        <div className="gamificationSection__toolbar">
          <button
            type="button"
            className="gamificationSection__avatarBtn"
            onClick={() => window.location.assign(`/profile/${this.props.currentUser.slug}`)}
            aria-label="View your profile"
          >
            <img
              src={avatarUrl}
              alt=""
              className="gamificationSection__avatar"
            />
          </button>
          <div className="gamificationSection__actions">
            <LexicoinCounter
              lexicoins={this.state.lexicoins}
              lexicoinIcon={this.props.lexicoin}
            />
            <NotificationBell
              confettiLottie={this.props.confettiLottie}
              lexicoin={this.props.lexicoin}
              closeIcon={this.props.closeIcon}
              refreshTrigger={this.props.notificationRefreshTrigger}
            />
          </div>
        </div>
      </div>
    )
  }

}

UserGamificationDashboard.propTypes = {
  currentUser: PropTypes.object.isRequired,
  lexicoin: PropTypes.string,
  missingImg: PropTypes.string,
  confettiLottie: PropTypes.string,
  closeIcon: PropTypes.string,
  notificationRefreshTrigger: PropTypes.number,
}

export default UserGamificationDashboard
